import { Box, Button, Container, FormControl, FormControlLabel, FormGroup, Grid, InputLabel, Link, MenuItem, Modal, Paper, Select, SelectChangeEvent, Stack, Switch, TextField, Tooltip, Typography, styled } from "@mui/material";
import React, { useEffect, useState } from "react"
import Title from "../components/Title";
import { Storefront } from "../models/StorefrontResponse";
import { useWalletBalance } from "../hooks/useWalletBalance";
import { useLookup } from "../hooks/useLookup";
//import { useLookupReport } from "../hooks/useLookupReport";
import LoadingSpinner from "../components/LoadingSpinner";
import ErrorFallBack from "../components/ErrorFallBack";
import { GridRenderCellParams } from "@mui/x-data-grid";
import { LookupResult } from "../models/Lookup";
import { DataGridPremium } from "@mui/x-data-grid-premium";
import LookupDetails from "../components/LookupDetails";
import { useNavigate } from "react-router-dom";
import AckLookup from "../components/AckLookup";
import { useTSGUser } from "../contexts/TSGUserContext";
//import { json2csv } from 'json-2-csv';


interface Props {
    storefront: Storefront,
}

const Lookup = (props: Props) => {
    const navigate = useNavigate();
    const [lookupType, setLookupType] = useState("");
    const [address, setAddress] = useState("");
    const [zipcode, setZipcode] = useState("");
    const [city, setCity] = useState("");
    const [stateLookup, setStateLookup] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [balanceRefreshKey, setBalanceRefreshKey] = useState(0);
    const [lookupRefreshKey, setLookupRefreshKey] = useState(0);
    //const [reportRefreshKey, setReportRefreshKey] = useState(0);
    const [lookupActionType, setLookupActionType] = useState("");
    const [openLookupDetails, setOpenLookupDetails] = useState(false);
    const [openLookupAcknowledgement, setOpenLookupAcknowledgment] = useState(false);
    const [lookupDetailsItem, setLookupDetailsItem] = useState<LookupResult>();
    const [lookupCreditCost, setLookupCreditCost] = useState(1);
    const [lookupID, setLookupID] = useState("");
    const [lookupChildID, setLookupChildID] = useState("");
    const [requirePhones, setRequirePhones] = useState(false);
    const [requireEmail, setRequireEmail] = useState(false);

    const { tsgUser } = useTSGUser();
    const { walletBalance } = useWalletBalance(tsgUser?.id || "", balanceRefreshKey)
    const { lookups, lookupsError, lookupsLoading } = useLookup(lookupActionType, firstName, lastName, address, city,
        stateLookup, zipcode, email, phone, lookupRefreshKey, tsgUser?.id || "", lookupCreditCost, lookupID, lookupChildID, requirePhones, requireEmail);
    //const { lookupReport } = useLookupReport(lookupID, "pdf", reportRefreshKey)

    useEffect(() => {
        loadState();
        setLookupCreditCost(props.storefront.lookupWalletCredits || 1);

        let foundAck = false;
        for (const ack of tsgUser?.acknowledgements || []) {
            if (ack.name === "lookup") {
                console.log("Lookup Acknowledgement Found")
                foundAck = true;
                break;
            }
        }
        if (!foundAck) {
            console.log("Lookup Acknowledgement Not Found. Prompting User...")
            setOpenLookupAcknowledgment(true);

        }

    }, [])

    useEffect(() => {
        saveState();
    }, [lookupType, address, zipcode, city, stateLookup, email, phone, firstName, lastName])

    useEffect(() => {
        if (lookups && lookups.results && lookups.results.length > 0) {
            setBalanceRefreshKey(balanceRefreshKey + 1);
        }
    }, [lookups])

    // useEffect(() => {
    //     if (!lookupAcknowledged) {
    //         setOpenLookupAcknowledgment(false);
    //     }
    // }, [lookupAcknowledged])

    // useEffect(() => {
    //     async function processBlob() {
    //         if (lookupReport && lookupReport.size > 0) {
    //             // console.log("Lookup Report Created: ", lookupReport.size)
    //             //console.log("lookupReport.tostring()", lookupReport.stream())
    //             //const blobString = await lookupReport.text();
    //             //console.log("blobString", blobString)
    //             //const decodedBlob = atob(blobString);
    //             // console.log("decodedBlob", decodedBlob)
    //             //const blob = new Blob([decodedBlob], { type: 'application/pdf' });

    //             // const pdfstr = await fetch(blobString);  
    //             // const blobFromFetch= await pdfstr.blob();


    //             // const blob = new Blob([blobFromFetch], {type: "application/pdf"});

    //             //const blob = base64toBlob(blobString);
    //             //console.log("lookupReport", lookupReport)


    //             const link = document.createElement('a');
    //             link.href = URL.createObjectURL(lookupReport);
    //             // some browser needs the anchor to be in the doc
    //             document.body.append(link);
    //             link.click();
    //             link.remove();
    //             setTimeout(() => URL.revokeObjectURL(link.href), 7000);
    //             //}


    //         } else {
    //             console.log("Lookup Report Not Created")
    //         }
    //     }

    //     processBlob();
    // }, [lookupReport])

    // useEffect(() => {
    //     let creditCost = 5
    //     if (props.storefront.lookupWalletCredits && props.storefront.lookupWalletCredits > 0) {
    //         creditCost = props.storefront.lookupWalletCredits
    //     }

    //     setLookupCreditCost(creditCost * lookupCount)
    // }, [lookupCount])

    const columns = [
        // { field: 'id', headerName: '#', width: 20 },
        {
            field: 'first', headerName: 'Name', width: 200, renderCell: (params: GridRenderCellParams) => {
                return <Typography variant="body2">{params.row.first} {params.row.last}</Typography>
            }
        },
        { field: 'address', headerName: 'Address', width: 280 },
        { field: 'city', headerName: 'City', width: 200 },
        { field: 'data_points', headerName: 'Data Points', width: 100 },
        {
            field: 'purchased', headerName: 'Action', width: 200, renderCell: (params: GridRenderCellParams) => {
                if (params.row.purchased) {
                    return <Button variant="contained" color="primary" onClick={() => {
                        console.log("params.row.data", params.row.data)
                        setLookupDetailsItem(params.row.data);
                        setOpenLookupDetails(true);
                    }}>View Details</Button>
                } else {
                    return <Button variant="contained" color="primary" onClick={() => purchaseButtonClicked(params.row.id)}>Purchase</Button>
                }
            }
        }
    ]

    const handleLookupTypeChange = (event: SelectChangeEvent) => {
        setLookupType(event.target.value as string);
    }

    const addressChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAddress(event.target.value);
    }

    const zipcodeChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setZipcode(event.target.value);
    }

    const cityChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCity(event.target.value);
    }

    const stateChanged = (event: SelectChangeEvent) => {
        setStateLookup(event.target.value as string);
    }

    const emailChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(event.target.value);
    }

    const phoneChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPhone(event.target.value);
    }

    const firstNameChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFirstName(event.target.value);
    }

    const lastNameChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLastName(event.target.value);
    }

    const handleAcknowledgement = (acknowledged: boolean) => {
        if (acknowledged) {
            handleLookupAcknowledgementClose();
        } else {
            navigate("/myorders")
        }
    }

    const purchaseButtonClicked = (lookupID: string) => {
        console.log("Purchase Button Clicked - Lookup ID: " + lookupID, "Lookup Child ID: " + lookupChildID)
        setLookupActionType("purchase");
        setLookupID(lookups?.id || "");
        setLookupChildID(lookupID);
        setLookupRefreshKey(lookupRefreshKey + 1);
    }

    const lookupButtonClicked = () => {
        // if (walletBalance && walletBalance.balance && walletBalance.balance <= lookupCreditCost) {
        //     alert("Insufficient funds in wallet. Please add funds to your wallet to continue.");
        //     return;
        // }
        setLookupActionType(lookupType);
        switch (lookupType) {
            case "address":
                setPhone("");
                setFirstName("");
                setLastName("");
                setEmail("");
                break;
            case "email":
                setPhone("");
                setFirstName("");
                setLastName("");
                setAddress("");
                setCity("");
                setZipcode("");
                setStateLookup("");
                break;
            case "phone":
                setFirstName("");
                setLastName("");
                setAddress("");
                setCity("");
                setZipcode("");
                setStateLookup("");
                setEmail("");
                break;
            case "person":
                setAddress("");
                setCity("");
                setZipcode("");
                setEmail("");
                setPhone("");
                break;
        }
        saveState();
        setLookupRefreshKey(lookupRefreshKey + 1);
    }

    // const lookupCountButtonClicked = () => {
    //     switch (lookupType) {
    //         case "address":
    //             setPhone("");
    //             setFirstName("");
    //             setLastName("");
    //             setEmail("");
    //             break;
    //         case "email":
    //             setPhone("");
    //             setFirstName("");
    //             setLastName("");
    //             setAddress("");
    //             setCity("");
    //             setZipcode("");
    //             setStateLookup("");
    //             break;
    //         case "phone":
    //             setFirstName("");
    //             setLastName("");
    //             setAddress("");
    //             setCity("");
    //             setZipcode("");
    //             setStateLookup("");
    //             setEmail("");
    //             break;
    //         case "person":
    //             setAddress("");
    //             setCity("");
    //             setZipcode("");
    //             setEmail("");
    //             setPhone("");
    //             break;
    //     }
    //     saveState();
    //     setLookupCountOnly(true);
    //     setLookupRefreshKey(lookupRefreshKey + 1);
    // }

    const saveState = () => {
        const pageName = "lookup";
        window.localStorage.setItem(pageName + "-lookupType", lookupType);
        window.localStorage.setItem(pageName + "-address", address);
        window.localStorage.setItem(pageName + "-zipcode", zipcode);
        window.localStorage.setItem(pageName + "-city", city);
        window.localStorage.setItem(pageName + "-stateLookup", stateLookup);
        window.localStorage.setItem(pageName + "-email", email);
        window.localStorage.setItem(pageName + "-phone", phone);
        window.localStorage.setItem(pageName + "-firstName", firstName);
        window.localStorage.setItem(pageName + "-lastName", lastName);
        console.log("Lookup State Saved")
    }

    const loadState = () => {
        const pageName = "lookup";
        setLookupType(window.localStorage.getItem(pageName + "-lookupType") || "");
        setAddress(window.localStorage.getItem(pageName + "-address") || "");
        setZipcode(window.localStorage.getItem(pageName + "-zipcode") || "");
        setCity(window.localStorage.getItem(pageName + "-city") || "");
        setStateLookup(window.localStorage.getItem(pageName + "-stateLookup") || "");
        setEmail(window.localStorage.getItem(pageName + "-email") || "");
        setPhone(window.localStorage.getItem(pageName + "-phone") || "");
        setFirstName(window.localStorage.getItem(pageName + "-firstName") || "");
        setLastName(window.localStorage.getItem(pageName + "-lastName") || "");
        console.log("Lookup State Loaded")
    }

    // const createExportURL = () => {
    //     try {
    //         const csv = json2csv(lookups?.results || [], { emptyFieldValue: "" });
    //         const blob = new Blob([csv], { type: 'text/csv' });
    //         const data = window.URL.createObjectURL(blob);
    //         return data;
    //     }
    //     catch (error) {
    //         console.log("Error creating export URL: " + error);
    //         return "";
    //     }
    // }

    const createExportJSONURL = () => {
        try {
            const json = JSON.stringify(lookups?.results || []);
            const blob = new Blob([json], { type: 'text/json' });
            const data = window.URL.createObjectURL(blob);
            return data;
        }
        catch (error) {
            console.log("Error creating export URL: " + error);
            return "";
        }
    }

    const createExportCSVURL = () => {
        try {
            const csv = json2csv((lookups?.results || []) as unknown as Record<string, unknown>[]);
            const blob = new Blob([csv], { type: 'text/csv' });
            const data = window.URL.createObjectURL(blob);
            return data;
        }
        catch (error) {
            console.log("Error creating export URL: " + error);
            return "";
        }
    }

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function flattenObject(obj: any, prefix = "", result: any = {}) {
    for (const key in obj) {
        if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
        const value = obj[key];
        if (typeof value === "object" && value !== null && !Array.isArray(value)) {
            flattenObject(value, prefix, result);
        } else if (Array.isArray(value)) {
            // If array of objects, flatten the first object
            if (value.length > 0 && typeof value[0] === "object" && value[0] !== null) {
                flattenObject(value[0], prefix, result);
            } else {
                result[prefix + key] = String(value);
            }
        } else {
            result[prefix + key] = String(value);
        }
    }
    return result;
}

function json2csv(json: Record<string, unknown>[]): string {
    // Flatten all rows
    const flatRows = json.map(row => flattenObject(row));

    // Collect all unique keys
    const allKeys = Array.from(
        flatRows.reduce((keys, row) => {
            Object.keys(row).forEach(k => keys.add(k));
            return keys;
        }, new Set<string>())
    );

    // Build CSV header
    const header = allKeys.join(",");

    // Build CSV rows
    const csvRows = flatRows.map((row: { [key: string]: string }) =>
        allKeys.map(key => {
            let value = row[key as string] ?? "";
            value = value.replace(/"/g, '""');
            if (/[",\n]/.test(value)) value = `"${value}"`;
            return value;
        }).join(",")
    );

    return [header, ...csvRows].join("\n");
}

    const downloadFilename = () => {
        return lookups?.id + "_LookupResults.json";
    }

    const downloadCSVFilename = () => {
        return lookups?.id + "_LookupResults.csv";
    }
    // const downloadPDF = () => {
    //     setLookupID(lookups?.id || "");
    //     setReportRefreshKey(reportRefreshKey + 1);
    //     console.log("Download PDF Clicked - Lookup ID: " + lookups?.id)
    // }

    function isViewLeadsButtonDisabled(): boolean {
        if (walletBalance?.balance === undefined) {
            return true;
        }

        return walletBalance?.balance < lookupCreditCost;
    }

    const StyledGridOverlay = styled('div')(({ theme }) => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        '& .ant-empty-img-1': {
            fill: theme.palette.mode === 'light' ? '#aeb8c2' : '#262626',
        },
        '& .ant-empty-img-2': {
            fill: theme.palette.mode === 'light' ? '#f5f5f7' : '#595959',
        },
        '& .ant-empty-img-3': {
            fill: theme.palette.mode === 'light' ? '#dce0e6' : '#434343',
        },
        '& .ant-empty-img-4': {
            fill: theme.palette.mode === 'light' ? '#fff' : '#1c1c1c',
        },
        '& .ant-empty-img-5': {
            fillOpacity: theme.palette.mode === 'light' ? '0.8' : '0.08',
            fill: theme.palette.mode === 'light' ? '#f5f5f5' : '#fff',
        },
    }));

    const hasPurchasedRecords = (): boolean => {
        if (lookups && lookups.results && lookups.results.length > 0) {
            for (let i = 0; i < lookups.results.length; i++) {
                if (lookups.results[i].purchased) {
                    return true;
                }
            }
        }
        return false
    }

    function CustomNoRowsOverlay() {
        return (
            <StyledGridOverlay>
                <Box width={100} sx={{ color: "#797a7a" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="-5.0 -10.0 110.0 135.0">
                        <path d="m22.211 51.91c-3.9648-9.7773-2.8984-20.871 2.8516-29.715 5.7539-8.8398 15.465-14.312 26.004-14.652 10.543-0.33984 20.586 4.4961 26.895 12.949 6.3086 8.4531 8.0898 19.457 4.7656 29.465l4.625 4.625-6.3984 6.3984 10.309 10.32c2.1016 2.1055 2.1016 5.5156-0.003907 7.6211-2.1016 2.1055-5.5156 2.1055-7.6211 0l-10.312-10.316-6.4023 6.4023-4.6211-4.625c-4.4297 1.4688-9.1289 1.9609-13.766 1.4453-0.007812 5.1562-1.9375 10.121-5.4141 13.926-3.4766 3.8047-8.25 6.1758-13.383 6.6445-5.1328 0.47266-10.254-0.99219-14.363-4.1016-4.1133-3.1094-6.9102-7.6445-7.8555-12.711-0.94141-5.0664 0.042969-10.305 2.7578-14.684 2.7188-4.3789 6.9727-7.5859 11.934-8.9922zm29.891-30.41c5.8047-0.011719 11.27 2.75 14.707 7.4297 0.50781 0.66797 1.457 0.80859 2.1328 0.3125 0.67969-0.49609 0.83203-1.4453 0.34766-2.1289-4.0195-5.4648-10.402-8.6953-17.188-8.6914-0.85156 0-1.543 0.69141-1.543 1.543 0 0.84766 0.69141 1.5391 1.543 1.5391zm17.297 12.379c0.32422 0.94141 0.56641 1.9102 0.72656 2.8906 0.16016 0.98828 0.24219 1.9922 0.23828 2.9922 0 0.85156 0.69141 1.5391 1.543 1.5391 0.84766 0 1.5391-0.6875 1.5391-1.5391 0-1.168-0.097656-2.332-0.28906-3.4844-0.1875-1.1484-0.46875-2.2812-0.84375-3.3828-0.27344-0.80469-1.1445-1.2383-1.9492-0.96484-0.80469 0.27344-1.2344 1.1445-0.96484 1.9492zm-33.332 42.891-4.9531-4.9531 4.9531-4.9492c0.86719-0.91016 0.85156-2.3438-0.035156-3.2305-0.89062-0.88672-2.3242-0.90234-3.2305-0.035157l-4.9531 4.9531-4.9492-4.9531c-0.90234-0.88281-2.3477-0.87109-3.2422 0.023438-0.89062 0.89062-0.90234 2.3359-0.023438 3.2422l4.9492 4.9492-4.9531 4.9531c-0.90234 0.90234-0.89844 2.3672 0.003906 3.2656 0.90234 0.90234 2.3672 0.90234 3.2656 0l4.9531-4.9492 4.9492 4.9492c0.90234 0.90234 2.3633 0.90234 3.2656 0s0.90234-2.3633 0-3.2656zm11.477-11.293c0.44922 0.078126 0.90234 0.14453 1.3633 0.19922 1.0625 0.12891 2.1328 0.19141 3.2031 0.19141 7.293-0.019532 14.242-3.0977 19.16-8.4805 4.918-5.3867 7.3555-12.586 6.7148-19.852-0.64062-7.2617-4.3008-13.926-10.082-18.367-5.7852-4.4414-13.168-6.2539-20.352-5-7.1836 1.2578-13.512 5.4688-17.441 11.613-3.9336 6.1406-5.1094 13.648-3.2461 20.699 0.42578 1.6094 1.0078 3.168 1.7383 4.6641 4.2461 0.15625 8.3398 1.6133 11.73 4.1797 3.3867 2.5625 5.9062 6.1094 7.2109 10.152zm-29.969-3.9297c-3.1914 3.1914-4.7188 7.6875-4.1328 12.168 0.58984 4.4766 3.2305 8.4297 7.1406 10.688 3.9102 2.2578 8.6523 2.5703 12.824 0.83984 4.1758-1.7266 7.3047-5.2969 8.4766-9.6602 1.168-4.3633 0.24219-9.0234-2.5078-12.605-2.75-3.5859-7.0117-5.6875-11.527-5.6875-3.8516-0.003906-7.5508 1.5273-10.273 4.2578z" fill="grey" />
                    </svg>
                </Box>
                <Box sx={{ mt: 1, color: "#797a7a" }}>No Results Found</Box>
            </StyledGridOverlay>
        );
    }

    const lookupDetailsStyle = {
        position: 'absolute',
        top: '40%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 800,
        bgcolor: props.storefront.activeColors.addProductForm.formBackground,
        border: '1px solid #5c5c5e',
        boxShadow: 24,
        p: 1,
    };

    const lookupAckStyle = {
        position: 'absolute',
        top: '40%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 700,
        bgcolor: props.storefront.activeColors.mainPage.headerBackground,
        border: '1px solid #5c5c5e',
        boxShadow: 24,
        p: 1,
    };

    const handleLookupDetailsClose = () => setOpenLookupDetails(false);
    const handleLookupAcknowledgementClose = () => setOpenLookupAcknowledgment(false);
    const handleFundWalletClicked = () => navigate("/mywallet");

    return (
        <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
                        <Title>Locate Property Owners & People</Title>
                        <Box>Search (i.e, skip trace) for people or properties based on name, address, phone or email address.</Box>
                        <Box>Payment of {props.storefront.lookupWalletCredits || 5} wallet credits for each lead is automatically deducted from your Wallet. <Link onClick={handleFundWalletClicked}>Fund your wallet</Link></Box>
                        <Stack sx={{ marginTop: 2 }}>
                            <FormControl fullWidth size="medium" sx={{ width: 300 }}>
                                <InputLabel id="lookup-type-label">Lookup Type</InputLabel>
                                <Select labelId="lookupType" label="Lookup Type" onChange={handleLookupTypeChange} size="medium" value={lookupType}>
                                    <MenuItem value="address" key="address">Property Address</MenuItem>
                                    <MenuItem value="email" key="email">Email Address</MenuItem>
                                    <MenuItem value="person" key="person">Person's Name</MenuItem>
                                    <MenuItem value="phone" key="phone">Phone Number</MenuItem>
                                </Select>
                            </FormControl>
                            {lookupType === "address" &&
                                <Stack sx={{ mt: 4 }}>
                                    <TextField fullWidth size="medium" sx={{ width: 400 }} label="Address" variant="outlined" value={address} onChange={addressChanged} />
                                    <Stack direction="row" sx={{ mt: 2 }} spacing={2} alignItems="center">
                                        <TextField fullWidth size="medium" sx={{ width: 150 }} label="Zip Code" variant="outlined" value={zipcode} onChange={zipcodeChanged} />
                                        <Typography>- OR -</Typography>
                                        <TextField fullWidth size="medium" sx={{ width: 200 }} label="City" variant="outlined" value={city} onChange={cityChanged} />
                                        <FormControl sx={{ width: 100 }}>
                                            <InputLabel id="lead-type-select-label" sx={{ marginTop: 0 }}>State</InputLabel>
                                            <Select value={stateLookup} id="outlined-basic" label="State" variant="outlined" size="medium" onChange={stateChanged} >
                                                <MenuItem value={"AK"}>AK</MenuItem>
                                                <MenuItem value={"AL"}>AL</MenuItem>
                                                <MenuItem value={"AR"}>AR</MenuItem>
                                                <MenuItem value={"AZ"}>AZ</MenuItem>
                                                <MenuItem value={"CA"}>CA</MenuItem>
                                                <MenuItem value={"CO"}>CO</MenuItem>
                                                <MenuItem value={"CT"}>CT</MenuItem>
                                                <MenuItem value={"DC"}>DC</MenuItem>
                                                <MenuItem value={"DE"}>DE</MenuItem>
                                                <MenuItem value={"FL"}>FL</MenuItem>
                                                <MenuItem value={"GA"}>GA</MenuItem>
                                                <MenuItem value={"HI"}>HI</MenuItem>
                                                <MenuItem value={"IA"}>IA</MenuItem>
                                                <MenuItem value={"ID"}>ID</MenuItem>
                                                <MenuItem value={"IL"}>IL</MenuItem>
                                                <MenuItem value={"IN"}>IN</MenuItem>
                                                <MenuItem value={"KS"}>KS</MenuItem>
                                                <MenuItem value={"KY"}>KY</MenuItem>
                                                <MenuItem value={"LA"}>LA</MenuItem>
                                                <MenuItem value={"MA"}>MA</MenuItem>
                                                <MenuItem value={"MD"}>MD</MenuItem>
                                                <MenuItem value={"ME"}>ME</MenuItem>
                                                <MenuItem value={"MI"}>MI</MenuItem>
                                                <MenuItem value={"MN"}>MN</MenuItem>
                                                <MenuItem value={"MO"}>MO</MenuItem>
                                                <MenuItem value={"MS"}>MS</MenuItem>
                                                <MenuItem value={"MT"}>MT</MenuItem>
                                                <MenuItem value={"NC"}>NC</MenuItem>
                                                <MenuItem value={"ND"}>ND</MenuItem>
                                                <MenuItem value={"NE"}>NE</MenuItem>
                                                <MenuItem value={"NH"}>NH</MenuItem>
                                                <MenuItem value={"NJ"}>NJ</MenuItem>
                                                <MenuItem value={"NM"}>NM</MenuItem>
                                                <MenuItem value={"NV"}>NV</MenuItem>
                                                <MenuItem value={"NY"}>NY</MenuItem>
                                                <MenuItem value={"OH"}>OH</MenuItem>
                                                <MenuItem value={"OK"}>OK</MenuItem>
                                                <MenuItem value={"OR"}>OR</MenuItem>
                                                <MenuItem value={"PA"}>PA</MenuItem>
                                                <MenuItem value={"RI"}>RI</MenuItem>
                                                <MenuItem value={"SC"}>SC</MenuItem>
                                                <MenuItem value={"SD"}>SD</MenuItem>
                                                <MenuItem value={"TN"}>TN</MenuItem>
                                                <MenuItem value={"TX"}>TX</MenuItem>
                                                <MenuItem value={"UT"}>UT</MenuItem>
                                                <MenuItem value={"VA"}>VA</MenuItem>
                                                <MenuItem value={"VT"}>VT</MenuItem>
                                                <MenuItem value={"WA"}>WA</MenuItem>
                                                <MenuItem value={"WI"}>WI</MenuItem>
                                                <MenuItem value={"WV"}>WV</MenuItem>
                                                <MenuItem value={"WY"}>WY</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Stack>
                                </Stack>
                            }
                            {lookupType === "email" &&
                                <Stack sx={{ mt: 4 }}>
                                    <TextField fullWidth size="medium" sx={{ width: 300 }} label="Email" variant="outlined" value={email} onChange={emailChanged} />
                                </Stack>
                            }
                            {lookupType === "phone" &&
                                <Stack sx={{ mt: 4 }}>
                                    <TextField fullWidth size="medium" sx={{ width: 300 }} label="Phone" variant="outlined" value={phone} onChange={phoneChanged} />
                                </Stack>
                            }
                            {lookupType === "person" &&
                                <Stack direction="row" sx={{ mt: 2 }} spacing={2} alignItems="center">
                                    <TextField fullWidth size="medium" sx={{ width: 240 }} label="First Name" variant="outlined" value={firstName} onChange={firstNameChanged} />
                                    <TextField fullWidth size="medium" sx={{ width: 240 }} label="Last Name" variant="outlined" value={lastName} onChange={lastNameChanged} />
                                    <FormControl sx={{ width: 100 }}>
                                        <InputLabel id="lead-type-select-label" sx={{ marginTop: 0 }}>State</InputLabel>
                                        <Select value={stateLookup} id="outlined-basic" label="State" variant="outlined" size="medium" onChange={stateChanged} >
                                            <MenuItem value={"AK"}>AK</MenuItem>
                                            <MenuItem value={"AL"}>AL</MenuItem>
                                            <MenuItem value={"AR"}>AR</MenuItem>
                                            <MenuItem value={"AZ"}>AZ</MenuItem>
                                            <MenuItem value={"CA"}>CA</MenuItem>
                                            <MenuItem value={"CO"}>CO</MenuItem>
                                            <MenuItem value={"CT"}>CT</MenuItem>
                                            <MenuItem value={"DC"}>DC</MenuItem>
                                            <MenuItem value={"DE"}>DE</MenuItem>
                                            <MenuItem value={"FL"}>FL</MenuItem>
                                            <MenuItem value={"GA"}>GA</MenuItem>
                                            <MenuItem value={"HI"}>HI</MenuItem>
                                            <MenuItem value={"IA"}>IA</MenuItem>
                                            <MenuItem value={"ID"}>ID</MenuItem>
                                            <MenuItem value={"IL"}>IL</MenuItem>
                                            <MenuItem value={"IN"}>IN</MenuItem>
                                            <MenuItem value={"KS"}>KS</MenuItem>
                                            <MenuItem value={"KY"}>KY</MenuItem>
                                            <MenuItem value={"LA"}>LA</MenuItem>
                                            <MenuItem value={"MA"}>MA</MenuItem>
                                            <MenuItem value={"MD"}>MD</MenuItem>
                                            <MenuItem value={"ME"}>ME</MenuItem>
                                            <MenuItem value={"MI"}>MI</MenuItem>
                                            <MenuItem value={"MN"}>MN</MenuItem>
                                            <MenuItem value={"MO"}>MO</MenuItem>
                                            <MenuItem value={"MS"}>MS</MenuItem>
                                            <MenuItem value={"MT"}>MT</MenuItem>
                                            <MenuItem value={"NC"}>NC</MenuItem>
                                            <MenuItem value={"ND"}>ND</MenuItem>
                                            <MenuItem value={"NE"}>NE</MenuItem>
                                            <MenuItem value={"NH"}>NH</MenuItem>
                                            <MenuItem value={"NJ"}>NJ</MenuItem>
                                            <MenuItem value={"NM"}>NM</MenuItem>
                                            <MenuItem value={"NV"}>NV</MenuItem>
                                            <MenuItem value={"NY"}>NY</MenuItem>
                                            <MenuItem value={"OH"}>OH</MenuItem>
                                            <MenuItem value={"OK"}>OK</MenuItem>
                                            <MenuItem value={"OR"}>OR</MenuItem>
                                            <MenuItem value={"PA"}>PA</MenuItem>
                                            <MenuItem value={"RI"}>RI</MenuItem>
                                            <MenuItem value={"SC"}>SC</MenuItem>
                                            <MenuItem value={"SD"}>SD</MenuItem>
                                            <MenuItem value={"TN"}>TN</MenuItem>
                                            <MenuItem value={"TX"}>TX</MenuItem>
                                            <MenuItem value={"UT"}>UT</MenuItem>
                                            <MenuItem value={"VA"}>VA</MenuItem>
                                            <MenuItem value={"VT"}>VT</MenuItem>
                                            <MenuItem value={"WA"}>WA</MenuItem>
                                            <MenuItem value={"WI"}>WI</MenuItem>
                                            <MenuItem value={"WV"}>WV</MenuItem>
                                            <MenuItem value={"WY"}>WY</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Stack>
                            }

                            <Stack direction="row" sx={{ mt: 2}} spacing={2} alignItems="center">
                                <FormGroup>
                                    <Tooltip title="If enabled, the lookup will only return results that have a phone number associated with them.">
                                        <FormControlLabel control={<Switch checked={requirePhones} onChange={(e) => setRequirePhones(e.target.checked)} />} label="Require Phone" />
                                    </Tooltip>
                                </FormGroup>
                                <FormGroup>
                                    <Tooltip title="If enabled, the lookup will only return results that have an email associated with them.">
                                        <FormControlLabel control={<Switch checked={requireEmail} onChange={(e) => setRequireEmail(e.target.checked)} />} label="Require Email" />
                                    </Tooltip>
                                </FormGroup>
                            </Stack>

                            <Box sx={{ mt: 1, mb: 4 }}>
                                <Stack direction="row" sx={{ mt: 1 }} spacing={2} alignItems="center">
                                    <Button variant="contained" color="primary" sx={{ width: 240 }} disabled={isViewLeadsButtonDisabled()} onClick={lookupButtonClicked}>Search</Button>
                                </Stack>
                            </Box>

                            <Stack direction="row" sx={{ mt: 4, mb: 1 }} alignItems="center" justifyContent="space-between">
                                <Typography variant="h5">Lookup Results</Typography>
                                {hasPurchasedRecords() &&
                                    <Stack direction="row" spacing={2}>
                                        <Link href={createExportJSONURL()} download={downloadFilename()}>
                                            <Button variant="contained" sx={{ width: 160 }}>Export as JSON</Button>
                                        </Link>
                                        <Link href={createExportCSVURL()} download={downloadCSVFilename()}>
                                            <Button variant="contained" sx={{ width: 160 }}>Export as CSV</Button>
                                        </Link>
                                    </Stack>
                                }
                                {/* {lookups?.results && lookups.results.length > 0 &&
                                    <Button variant="contained" sx={{ width: 160 }} onClick={downloadPDF}>Download PDF</Button>
                                } */}
                            </Stack>

                            {/* {lookups?.results && lookups?.results.length > 0 &&
                                <Typography>The cost is {lookupCreditCost} wallet credits to access each result. Credits will be automatically deducted from your wallet.</Typography>
                            } */}
                            {lookups?.results && lookups?.results.length > 0 && walletBalance?.balance && walletBalance?.balance < lookupCreditCost &&
                                <Box>
                                    <Typography sx={{ mt: 2 }}>Wallet Balance: {walletBalance?.balance}</Typography>
                                    <Typography sx={{ color: "red" }}>Insufficient credits in wallet.</Typography>
                                    <Link onClick={() => navigate("/mywallet")} download>Add Credits</Link>
                                </Box>
                            }

                            <Grid height={500}>
                                {lookupsLoading
                                    ? <LoadingSpinner title="Conducting Lookup..." textColor={props.storefront.activeColors.mainPage.pageText} />
                                    : lookupsError
                                        ? <ErrorFallBack message={lookupsError} />
                                        : <DataGridPremium
                                            rows={lookups?.results || []}
                                            columns={columns}
                                            initialState={{
                                                sorting: {
                                                    sortModel: [{ field: 'id', sort: 'asc' }],
                                                },
                                            }}
                                            slots={{
                                                noRowsOverlay: CustomNoRowsOverlay,
                                            }}
                                        />
                                }
                            </Grid>
                        </Stack>
                    </Paper>
                </Grid>
            </Grid>
            <Modal
                open={openLookupDetails}
                onClose={handleLookupDetailsClose}
            >
                <Box sx={lookupDetailsStyle}>
                    <LookupDetails lookupResult={lookupDetailsItem || {}} close={() => { setOpenLookupDetails(false) }} storefront={props.storefront} />
                </Box>
            </Modal>
            <Modal
                open={openLookupAcknowledgement}
                onClose={handleLookupAcknowledgementClose}
            >
                <Box sx={lookupAckStyle}>
                    <AckLookup customerID={tsgUser?.id || ""} acknowledgement={handleAcknowledgement} storefront={props.storefront} />
                </Box>
            </Modal>
        </Container>
    )
}

export default Lookup;